/*!
 * capture-source.js — ECOTHATCH, boutique shop.ecothatch.com : d'où vient chaque lead.
 * Version boutique du 2026-10-27, NON DÉPLOYÉE. Écrite en ES5 (aucune syntaxe moderne).
 * Essais hors ligne : essais/lancer-tout.mjs (scénarios, versions abîmées, ES5, Liquid, relève).
 *
 * Ce que le script garde : les identifiants de clic publicitaire (gclid, gbraid, wbraid,
 * fbclid), les 5 UTM, la page d'arrivée et le site d'origine SANS leurs paramètres, et
 * l'heure du clic. Jamais de nom, de courriel ni de téléphone. Il n'envoie rien nulle part.
 *
 * TÉMOIN « et_source » — le même contrat que le site www et la relève de Pulse :
 *   Domain=.ecothatch.com ; Path=/ ; Max-Age=7776000 (90 jours) ; SameSite=Lax ; Secure ;
 *   pas HttpOnly. Valeur = encodeURIComponent(JSON.stringify(objet)), avec
 *   objet = { v: 1, gclid?, gbraid?, wbraid?, fbclid?, fbc?, utm_source?, utm_medium?,
 *             utm_campaign?, utm_content?, utm_term?, page_arrivee, referrer?, capte_le }.
 *   1. Un click id dans l'adresse : l'objet ENTIER est remplacé (nouveau clic publicitaire).
 *      fbclid donne aussi fbc = "fb.1.<heure en ms>.<fbclid>", fbclid recopié tel quel.
 *   2. Seulement des UTM : si l'objet gardé a un click id, on n'y touche PAS ; sinon on le
 *      remplace par ces UTM.
 *   3. Ni click id ni UTM : on ne touche à rien.
 *   4. Nettoyage : caractères de contrôle retirés (avec les séparateurs de ligne Unicode
 *      U+2028/U+2029 et les inverseurs d'écriture, que la relève des leads refuserait),
 *      espaces aux bouts retirés ; une valeur de plus de 400 caractères est IGNORÉE (un
 *      click id tronqué serait faux) — fbc compris : un fbclid de plus de 381 caractères
 *      donne un fbc trop long, qui n'est pas gardé (fbclid, lui, l'est) ; un click id
 *      hors ^[A-Za-z0-9._~-]+$ est ignoré ; page et site d'origine sans paramètres, et le
 *      site d'origine seulement en https://.
 *
 * CONFIDENTIALITÉ — une seule règle : « dans le doute, on compte moins ».
 *   - Signal GPC du navigateur, ou NON explicite au marketing dans l'API Customer Privacy de
 *     Shopify (marketingAllowed() === false et choix « no », ou refus fait dans le bandeau) :
 *     rien n'est gardé, le témoin est effacé et les champs cachés restent vides.
 *   - Pas de réponse de l'API (pas encore chargée, en panne, bloquée), ou pas encore de
 *     choix là où Shopify exige un accord : on ne capte rien et on ne remplit rien, sans rien
 *     effacer (ce n'est pas un refus). AUCUN délai de grâce : dès que la réponse arrive,
 *     elle s'applique.
 *   - L'API répond OUI : on capte et on remplit.
 *   - Un nouveau choix fait dans le bandeau (événement visitorConsentCollected) s'applique
 *     aussitôt.
 *
 * CHAMPS CACHÉS (snippets/champs-source-auto.liquid) : marqués data-source-auto="<nom>" et
 * DÉSACTIVÉS au départ ; un champ désactivé ne part pas avec le formulaire. Le script les
 * remplit au chargement, à chaque nouveau choix de confidentialité et à l'envoi (où il capte
 * aussi l'adresse, si l'accord est arrivé sans que son rappel soit appelé) ; un champ
 * sans valeur reste désactivé, donc absent du courriel de Shopify. contact[formulaire]
 * n'est jamais touché ici : sa valeur fixe vient du Liquid.
 *
 * L'ENVOI NE CASSE JAMAIS : tout est sous try/catch, et le script n'appelle jamais
 * preventDefault ni stopPropagation.
 */
(function () {
  'use strict';

  var TEMOIN = 'et_source';
  var DOMAINE = 'ecothatch.com';
  var DUREE_S = 7776000; // 90 jours
  var LONGUEUR_MAX = 400; // au-delà, la valeur est IGNORÉE
  var TAILLE_MAX = 3800; // un témoin de plus de 4 Ko est refusé EN SILENCE par le navigateur
  var CLICS = ['gclid', 'gbraid', 'wbraid', 'fbclid'];
  var UTMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  // Les clés du témoin (sauf v), dans l'ordre où elles sont écrites.
  var CLES = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'fbc', 'utm_source', 'utm_medium',
    'utm_campaign', 'utm_content', 'utm_term', 'page_arrivee', 'referrer', 'capte_le'];
  // Témoin trop gros : on retire ces clés, dans cet ordre. Jamais un click id ni fbc.
  var SACRIFIABLES = ['utm_term', 'utm_content', 'referrer', 'utm_campaign', 'utm_medium',
    'utm_source', 'page_arrivee'];
  // Contrôles C0 et C1, séparateurs de ligne Unicode, inverseurs d'écriture : la même liste
  // que la relève des leads, qui REFUSE une valeur qui en porte.
  // Bâtie à partir des CODES des caractères, sans séquence d'échappement : un outil de copie qui
  // remplacerait le texte d'échappement de U+2028 par le caractère lui-même casserait une
  // expression régulière écrite en toutes lettres (piège vu le 2026-10-27).
  function plage(de, a) {
    return String.fromCharCode(de) + '-' + String.fromCharCode(a);
  }
  var RE_CONTROLE = new RegExp('[' + plage(0x00, 0x1f) + plage(0x7f, 0x9f) + plage(0x2028, 0x2029)
    + plage(0x202a, 0x202e) + plage(0x2066, 0x2069) + ']', 'g');
  var RE_CLIC = /^[A-Za-z0-9._~-]+$/;
  var RE_FBC = /^fb\.1\.\d{1,16}\.[A-Za-z0-9._~-]+$/;
  var RE_FBP = /^fb\.\d\.\d+\.\d+$/;
  var RE_ADRESSE = /^https:\/\/[^\s?#]+$/;
  var RE_DATE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,3})?Z$/;
  var aSoi = Object.prototype.hasOwnProperty;
  var dejaCapte = false;

  function dans(liste, x) {
    for (var i = 0; i < liste.length; i++) {
      if (liste[i] === x) return true;
    }
    return false;
  }

  function nettoyer(v) {
    return typeof v === 'string' ? v.replace(RE_CONTROLE, '').trim() : '';
  }

  // Nettoyée, non vide et de 400 caractères au plus ; sinon null.
  function propre(v) {
    var s = nettoyer(v);
    return s !== '' && s.length <= LONGUEUR_MAX ? s : null;
  }

  // Une valeur validée selon sa clé ; null si elle ne respecte pas le contrat.
  // 400 caractères au plus pour TOUTES les clés, fbc compris (règle 4 ; la relève refuse au-delà).
  function valeurValide(cle, brut) {
    var v = propre(brut);
    if (v === null) return null;
    if (cle === 'fbc') return RE_FBC.test(v) ? v : null;
    if (dans(CLICS, cle)) return RE_CLIC.test(v) ? v : null;
    if (cle === 'page_arrivee' || cle === 'referrer') return RE_ADRESSE.test(v) ? v : null;
    if (cle === 'capte_le') return RE_DATE.test(v) ? v : null;
    return v; // UTM : texte libre, nettoyé
  }

  function decoderParametre(x) {
    try {
      return decodeURIComponent(x.replace(/\+/g, ' '));
    } catch (e) {
      return null; // encodage abîmé : valeur ignorée
    }
  }

  function decoderTemoin(x) {
    try {
      return decodeURIComponent(x);
    } catch (e) {
      return null;
    }
  }

  // Les 9 paramètres suivis, lus dans l'adresse. La 1re valeur d'un nom gagne.
  function parametres(recherche) {
    var trouves = {};
    var texte = typeof recherche === 'string' ? recherche.replace(/^\?/, '') : '';
    var paires = texte === '' ? [] : texte.split('&');
    for (var i = 0; i < paires.length; i++) {
      var egal = paires[i].indexOf('=');
      var nom = decoderParametre(egal >= 0 ? paires[i].slice(0, egal) : paires[i]);
      if (nom === null || aSoi.call(trouves, nom) || !(dans(CLICS, nom) || dans(UTMS, nom))) continue;
      trouves[nom] = decoderParametre(egal >= 0 ? paires[i].slice(egal + 1) : '');
    }
    return trouves;
  }

  // Les valeurs brutes de tous les témoins qui portent ce nom.
  function temoinsBruts(nom) {
    var brut;
    try {
      brut = document.cookie;
    } catch (e) {
      return []; // témoins interdits par le navigateur
    }
    var morceaux = typeof brut === 'string' && brut !== '' ? brut.split(';') : [];
    var valeurs = [];
    for (var i = 0; i < morceaux.length; i++) {
      var m = morceaux[i].replace(/^\s+/, '');
      var egal = m.indexOf('=');
      if (egal > 0 && m.slice(0, egal) === nom) valeurs.push(m.slice(egal + 1));
    }
    return valeurs;
  }

  // Le témoin gardé, validé clé par clé ; null s'il manque ou s'il est illisible.
  function lireGarde() {
    var bruts = temoinsBruts(TEMOIN);
    for (var i = 0; i < bruts.length; i++) {
      var texte = bruts[i];
      if (texte.length > 1 && texte.charAt(0) === '"' && texte.charAt(texte.length - 1) === '"') {
        texte = texte.slice(1, -1);
      }
      texte = decoderTemoin(texte);
      // Toléré : une valeur encodée deux fois (cookies.set de Next.js encode déjà la valeur).
      if (texte !== null && texte.charAt(0) !== '{') texte = decoderTemoin(texte);
      if (texte === null) continue;
      var objet;
      try {
        objet = JSON.parse(texte);
      } catch (e) {
        continue;
      }
      if (objet === null || typeof objet !== 'object' || objet.v !== 1) continue;
      var garde = {};
      for (var j = 0; j < CLES.length; j++) {
        if (!aSoi.call(objet, CLES[j])) continue;
        var v = valeurValide(CLES[j], objet[CLES[j]]);
        if (v !== null) garde[CLES[j]] = v;
      }
      return garde;
    }
    return null;
  }

  function aUnClic(objet) {
    for (var i = 0; i < CLICS.length; i++) {
      if (aSoi.call(objet, CLICS[i])) return true;
    }
    return false;
  }

  // Sur *.ecothatch.com, le témoin est partagé par www et shop. Ailleurs (lien d'aperçu
  // Shopify), il reste propre à cette adresse.
  function chezNous() {
    var hote = String(location.hostname || '').toLowerCase();
    return hote === DOMAINE || hote.slice(-(DOMAINE.length + 1)) === '.' + DOMAINE;
  }

  function poser(valeur, dureeS, avecDomaine) {
    try {
      document.cookie = TEMOIN + '=' + valeur + '; Path=/; Max-Age=' + dureeS
        + (avecDomaine ? '; Domain=.' + DOMAINE : '')
        + '; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
    } catch (e) {
      // Témoins bloqués : rien d'autre ne change.
    }
  }

  function ecrire(objet) {
    var valeur = encodeURIComponent(JSON.stringify(objet));
    for (var i = 0; valeur.length > TAILLE_MAX && i < SACRIFIABLES.length; i++) {
      delete objet[SACRIFIABLES[i]];
      valeur = encodeURIComponent(JSON.stringify(objet));
    }
    var partage = chezNous();
    if (partage) poser('', 0, false); // une ancienne copie sans domaine masquerait la nouvelle
    poser(valeur, DUREE_S, partage);
  }

  function effacer() {
    if (temoinsBruts(TEMOIN).length === 0) return;
    if (chezNous()) poser('', 0, true);
    poser('', 0, false);
  }

  // Le site d'où vient le visiteur : origine + chemin, sans paramètres, seulement en https://.
  function referrerPropre(adresse) {
    var m = typeof adresse === 'string' ? /^https:\/\/([^\/?#]*)([^?#]*)/i.exec(adresse) : null;
    if (!m) return null;
    var hote = m[1].slice(m[1].lastIndexOf('@') + 1).toLowerCase().replace(/:443$/, '');
    return hote === '' ? null : valeurValide('referrer', 'https://' + hote + (m[2] || '/'));
  }

  function capter() {
    var p = parametres(location.search);
    var lu = {};
    var clic = false;
    var utm = false;
    var i, v;
    for (i = 0; i < CLICS.length; i++) {
      v = aSoi.call(p, CLICS[i]) ? valeurValide(CLICS[i], p[CLICS[i]]) : null;
      if (v !== null) {
        lu[CLICS[i]] = v;
        clic = true;
      }
    }
    for (i = 0; i < UTMS.length; i++) {
      v = aSoi.call(p, UTMS[i]) ? valeurValide(UTMS[i], p[UTMS[i]]) : null;
      if (v !== null) {
        lu[UTMS[i]] = v;
        utm = true;
      }
    }
    if (!clic && !utm) return; // règle 3 : on ne touche à rien
    if (!clic) {
      var garde = lireGarde();
      if (garde !== null && aUnClic(garde)) return; // règle 2 : des UTM n'écrasent jamais un clic
    }
    var maintenant = Date.now();
    // fbc de plus de 400 caractères (fbclid de plus de 381) : null, donc pas gardé.
    if (lu.fbclid) lu.fbc = valeurValide('fbc', 'fb.1.' + maintenant + '.' + lu.fbclid);
    lu.page_arrivee = valeurValide('page_arrivee', location.protocol + '//' + location.host + location.pathname);
    lu.referrer = referrerPropre(document.referrer);
    lu.capte_le = new Date(maintenant).toISOString();
    var objet = { v: 1 };
    for (i = 0; i < CLES.length; i++) {
      if (aSoi.call(lu, CLES[i]) && lu[CLES[i]] !== null) objet[CLES[i]] = lu[CLES[i]];
    }
    ecrire(objet);
  }

  // Les valeurs à envoyer : le témoin validé, plus le témoin _fbp de Meta s'il est valide.
  function valeurs() {
    var v = lireGarde() || {};
    var fbp = temoinsBruts('_fbp');
    for (var i = 0; i < fbp.length; i++) {
      var f = propre(decoderTemoin(fbp[i])); // 400 caractères au plus, comme le reste
      if (f !== null && RE_FBP.test(f)) {
        v.fbp = f;
        break;
      }
    }
    return v;
  }

  // « oui », « non » ou « inconnu ». choix : la réponse portée par l'événement du bandeau.
  function etat(choix) {
    try {
      if (navigator.globalPrivacyControl === true) return 'non';
    } catch (e) {
      // navigator illisible : on passe à Shopify
    }
    if (choix === true || choix === false) return choix ? 'oui' : 'non';
    var api;
    try {
      api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api || typeof api.marketingAllowed !== 'function') return 'inconnu';
      var permis = api.marketingAllowed();
      if (permis === true) return 'oui';
      if (permis !== false) return 'inconnu';
    } catch (e) {
      return 'inconnu';
    }
    // marketingAllowed() === false : un refus, ou pas encore de choix là où il faut un accord.
    try {
      if (api.currentVisitorConsent().marketing === '') return 'inconnu'; // pas encore de choix : on attend
    } catch (e) {
      // Impossible de savoir pourquoi : traité comme un refus.
    }
    return 'non';
  }

  // Remplit les champs cachés ; un champ sans valeur est désactivé, donc n'est pas envoyé.
  function remplir(e) {
    var v = e === 'oui' ? valeurs() : {};
    var champs;
    try {
      champs = document.querySelectorAll('input[data-source-auto]');
    } catch (err) {
      return;
    }
    for (var i = 0; i < champs.length; i++) {
      try {
        var nom = champs[i].getAttribute('data-source-auto');
        var val = typeof nom === 'string' && aSoi.call(v, nom) ? v[nom] : '';
        champs[i].value = val;
        champs[i].disabled = val === '';
      } catch (err) {
        // Un champ en panne ne bloque ni les autres ni l'envoi.
      }
    }
  }

  function appliquer(evenement) {
    try {
      var d = evenement && evenement.detail;
      var e = etat(d ? d.marketingAllowed : null);
      if (e === 'non') {
        effacer();
        dejaCapte = false;
      }
      if (e === 'oui' && !dejaCapte) {
        dejaCapte = true;
        capter();
      }
      remplir(e);
    } catch (err) {
      // Jamais d'erreur visible pour le visiteur.
    }
  }

  // À l'envoi, en phase de capture (avant la protection hCaptcha de Shopify, qui écoute la
  // page plus tard, en bouillonnement), on refait ce qui manque : capter l'adresse si l'accord
  // est arrivé sans que notre rappel soit appelé, puis remplir. appliquer() ne lève jamais
  // d'erreur et n'appelle ni preventDefault ni stopPropagation : l'envoi continue toujours.
  document.addEventListener('submit', function () {
    appliquer(null);
  }, true);
  document.addEventListener('visitorConsentCollected', appliquer);

  // API de confidentialité de Shopify : https://shopify.dev/docs/api/customer-privacy
  try {
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function () {
        appliquer(null);
      });
    }
  } catch (err) {
    // API absente : l'état reste « inconnu », donc on ne compte pas.
  }
  appliquer(null);
})();
